module.exports = __webpack_public_path__ + "static/img/logo_right.1e633a0e.png";